module.exports = __webpack_public_path__ + "img/67.2.TN.3f6ceb6e.png";